<template>
    <div>
        <Modal v-on:close="$emit('close')">
            <Loader v-if="loading" />
            <template v-else>
                <div class="input-row small-margin-bottom">
                    <span class="label">Transfer to</span>
                    <select v-model="transfer_to">
                        <option v-for="stylist in getStylists" :value="stylist.id">{{ stylist.shortened_name }}</option>
                    </select>
                </div>
                <button :disabled="saving" v-on:click="confirm()">Confirm</button>
                <div class="note small-margin-top">The customer will not be notified of transfers</div>
            </template>
        </Modal>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'id',
    'customer'
  ],
  data: () => ({
    record: {},
    stylists: [],
    transfer_to: false,
    saving: false
  }),
  computed: {
    ...mapGetters([
      'getStylists'
    ]),
    loading () {
      return !this.stylists.length
    }
  },
  methods: {
    load () {
      Vue.$api.get('/stylists', {}, {
        callback: data => this.stylists = data
      })
    },
    confirm () {
      Vue.$api.post('/order/' + this.id + '/transfer-to-stylist', {
        stylist_id: this.transfer_to
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.success()
      })
    },
    success () {
      this.$emit('success')
    }
  },
  created () {
    this.load()
  }
}
</script>
